import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withMap } from 'react-mapbox-gl/lib-esm/context';

const baseCls = 'lt-map-zoom-controls';

class ZoomControl extends React.Component {
  onClickPlus = () => {
    const { map, onControlClick, zoomDiff } = this.props;
    onControlClick(map, zoomDiff);
  };

  onClickMinus = () => {
    const { map, onControlClick, zoomDiff } = this.props;
    onControlClick(map, -zoomDiff);
  };

  render() {
    const { className, tabIndex, style, disabled } = this.props;

    return (
      <div
        className={cn(baseCls, className, {
          [`${baseCls}--disabled`]: disabled,
        })}
        tabIndex={tabIndex}
        style={style}
      >
        <button
          className={`${baseCls}__button ${baseCls}__in`}
          type="button"
          aria-label="Zoom in"
          onClick={this.onClickPlus}
          disabled={disabled}
        />
        <button
          className={`${baseCls}__button ${baseCls}__out`}
          type="button"
          aria-label="Zoom out"
          onClick={this.onClickMinus}
          disabled={disabled}
        />
      </div>
    );
  }
}

ZoomControl.defaultProps = {
  zoomDiff: 0.5,
  onControlClick: (map, zoomDiff) => {
    map.zoomTo(map.getZoom() + zoomDiff);
  },
  className: null,
  tabIndex: 0,
  style: null,
  disabled: false,
};

ZoomControl.propTypes = {
  className: PropTypes.string,
  tabIndex: PropTypes.number,
  zoomDiff: PropTypes.number,
  onControlClick: PropTypes.func,
  map: PropTypes.shape({}).isRequired,
  style: PropTypes.shape({}),
  disabled: PropTypes.bool,
};

export default withMap(ZoomControl);
